<template>
  <el-row :gutter="18"
          class="edit">
    <el-form :model="sector">
      <el-col :md="12">
        <!-- Sector Name-->
        <el-form-item label="Nombre del sector">
          <el-input v-model="sector.name"
                    size="mini"/>
        </el-form-item>
        <!-- Enterprise -->
        <el-form-item label="Empresa">
          <el-select  v-model="sector.enterprise"
                      value-key="id"
                      clearable
                      filterable
                      size="mini"
                      @change="getDataPatent"
                      placeholder="Ej: nombre empresa">
            <el-option  v-for="enterprise in enterpriseList"
                        :key="enterprise.id"
                        :label="enterprise.name"
                        :value="{ id: enterprise.id, name: enterprise.name }"/>
          </el-select>
        </el-form-item>
        <!-- Vehicles -->
        <el-form-item label="Patentes">
          <el-select  v-model="sector.vehicles"
                      :disabled="this.myPatents.length < 1"
                      multiple
                      filterable
                      clearable
                      collapse-tags
                      size="mini"
                      placeholder="Ej: TEST-123"
                      class="mini-loader"
                      v-loading="loadPatent"
                      @change="updateMaximumVolume()">
            <el-option  v-for="vehicle in myPatents"
                        :key="vehicle.id"
                        :label="vehicle.patent"
                        :value="vehicle.id"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <!-- Package Type -->
        <el-form-item label="Tamaño">
          <el-checkbox v-model="checkAllPackage"
                       class="btn-select-all"
                       @change="selectAllPackages">
            <span class="check-label">seleccionar todos los tamaños</span>
          </el-checkbox>
          <el-select  v-model="sector.packageTypes"
                      value-key="id"
                      multiple
                      clearable
                      size="mini"
                      collapse-tags
                      filterable
                      @change="verifySelected('packages')"
                      placeholder="Ej: MM">
            <el-option  v-for="packageType in packageTypeList"
                        :key="packageType.id"
                        :label="packageType.type"
                        :value="{ id: packageType.id, type: packageType.type }"/>
          </el-select>
        </el-form-item>
        <!-- Region -->
        <el-form-item label="Región"
                      v-show="sector.mode === 'LOCALIDAD'">
          <el-select  v-model="sector.region"
                      value-key="id"
                      filterable
                      size="mini"
                      @change="getDataLocality"
                      placeholder="Ej: Region Metropolitana">
            <el-option  v-for="region in regionList"
                        :key="region.id"
                        :label="region.name"
                        :value="{ id: region.id, name: region.name }"/>
          </el-select>
        </el-form-item>
        <!-- Locality -->
        <el-form-item label="Localidad">
          <el-checkbox v-model="checkAllLocality"
                       class="btn-select-all"
                       :disabled="this.localitiesOfRegion.length < 1"
                       @change="selectAllLocalities">
            <span class="check-label">seleccionar todas las localidades</span>
          </el-checkbox>
          <el-select  v-model="sector.localities"
                      value-key="id"
                      collapse-tags
                      @change="verifySelected('localities')"
                      :disabled="this.localitiesOfRegion.length < 1"
                      multiple
                      filterable
                      size="mini"
                      clearable
                      placeholder="Ej: Maipú">
            <el-option  v-for="locality in localitiesOfRegion"
                        :key="locality.id"
                        :label="locality.name"
                        :value="{ id: locality.id, name: locality.name }"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-form>
    <el-col class="option">
      <el-button size="small"
                 class="danger"
                 @click="remove">
        <i class="far fa-trash-alt"/>ELIMINAR
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
import { cachedAPIRequest } from '../../../../../mixins/cacheDim';

export default {
  name: 'LocalityForm',
  components: {
  },
  props: {
    sector: {
      type: Object,
      default() {
        return {};
      },
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      myPatents: [],
      regionList: [],
      myLocalities: [],
      localityList: [],
      loadPatent: false,
      enterpriseList: [],
      packageTypeList: [],
      preselectRegion: true,
      checkAllPackage: false,
      checkAllLocality: false,
    };
  },
  mounted() {
    this.getRegionList();
    this.getLocalityList();
    this.getEnterpriseList();
    this.getPackageTypeList();
    if (this.sector.enterprise.id) this.getPatents();
    this.verifySelected('packages');
    this.verifySelected('localities');
  },
  methods: {
    remove() {
      this.$confirm('¿Está seguro que desea eliminar el sector?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.$emit('remove');
      }).catch(() => {});
    },
    verifySelected(type) {
      if (type === 'packages') this.checkAllPackage = this.allPackagesSelected;
      if (type === 'localities') this.checkAllLocality = this.allLocalitiesSelected;
    },
    selectAllPackages(value) {
      this.sector.packageTypes = value ? this.packageTypeList : [];
    },
    selectAllLocalities(value) {
      this.sector.localities = value ? this.localitiesOfRegion : [];
    },
    updateMaximumVolume() {
      this.sector.maximumVolume = this.calculateVolumen();
      this.sector.maximumPrice = this.calculatePrice();
    },
    calculateVolumen() {
      return this.sector.vehicles.reduce((acc, id) => {
        const measure = this.myPatents.find(v => v.id === id);
        return acc + measure.max_volume;
      }, 0);
    },
    calculatePrice() {
      return this.sector.vehicles.reduce((acc, id) => {
        const price = this.myPatents.find(v => v.id === id);
        return acc + price.max_insurance;
      }, 0);
    },
    getRegionList() {
      this.regionList = this.data.regionList;
    },
    getLocalityList() {
      this.localityList = this.data.localityList;
    },
    getEnterpriseList() {
      this.enterpriseList = this.data.enterpriseList;
    },
    getPackageTypeList() {
      this.packageTypeList = this.data.packageTypeList;
    },
    getDataLocality() {
      this.sector.localities = [];
      this.checkAllLocality = false;
    },
    getDataPatent() {
      this.sector.vehicles = [];
      if (this.sector.enterprise.id) this.getPatents();
    },
    getPatents() {
      this.loadPatent = true;
      cachedAPIRequest({
        module: 'planning',
        service: 'get_patents',
        pathparam: { id: this.sector.enterprise.id },
        params: { limit: 1000 },
      }).then((data) => {
        this.myPatents = data.data.sort((a, b) => (b.patent > a.patent ? -1 : 1));
        this.loadPatent = false;
        if (this.myPatents.length < 1) {
          this.$notify.warning({
            title: 'Advertencia',
            message: 'Empresa sin patentes activas',
          });
        }
      }).catch(() => {
        this.loadPatent = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las patentes',
        });
      });
    },
  },
  computed: {
    localitiesOfRegion() {
      return this.localityList.filter(l => l.commune.regions_id === this.sector.region.id)
        .sort((a, b) => (b.name > a.name ? -1 : 1));
    },
    allPackagesSelected() {
      return this.sector.packageTypes.length === this.packageTypeList.length;
    },
    allLocalitiesSelected() {
      return this.sector.localities.length === this.localitiesOfRegion.length;
    },
  },
};
</script>

<style lang="scss" scoped>
  .edit {
    padding: 20px 10px 10px;
    .el-form-item { margin-bottom: 12px; }
    .btn-select-all {
      float: right;
      height: 25px;
      margin: -18px 2px 0 0;
      .check-label {
        font-size: 11px;
        margin-left: -4px;
      }
    }
    .option {
      margin-top: 20px;
      text-align: right;
      i {
        margin-right: 8px;
        margin-left: -5px;
      }
    }
  }
</style>
